package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class SyndromeIndicationUpperPathogenesis(private val literal: String) : IEnumType {
	虚("虚"),
	实("实"),
	寒("寒"),
	热("热"),
	痰饮("痰饮"),
	水气("水气"),
	湿("湿"),
	瘀血("瘀血");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "syndrome_indication_upper_pathogenesis"}
	override fun getLiteral(): String {return literal}
}
